module.exports = __webpack_public_path__ + "img/3_2_2.8d23fb5d.png";